import { render, staticRenderFns } from "./TaxAssessmentAdditionalInfo.vue?vue&type=template&id=8368d1be&"
import script from "./TaxAssessmentAdditionalInfo.vue?vue&type=script&lang=ts&"
export * from "./TaxAssessmentAdditionalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports